import { render, staticRenderFns } from "./appointmentList.vue?vue&type=template&id=393519d6&scoped=true&"
import script from "./appointmentList.vue?vue&type=script&lang=js&"
export * from "./appointmentList.vue?vue&type=script&lang=js&"
import style0 from "./appointmentList.vue?vue&type=style&index=0&id=393519d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393519d6",
  null
  
)

export default component.exports